import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';

import AddFoodCompActionModalContainer from './AddFoodCompActionModalContainer';
import {setFoodcompositionAddFoodCompModal} from '../../../../store/slice/PharmaSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width: { lg: '55%', xs: '95%' },
  height: { lg: '55%', xs: '95%' },
  borderRadius: 3,
  //overflow:'scroll',
  p: 1,
  backgroundColor:'secondary.lighter',
};

export default function AddFoodCompActionModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);;
  const {AddFoodCompModalOpen, foodcompositionObj} = useSelector((state)=>state.pharmaslice.foodcompositionDashboard);

  useEffect(()=>{
  },[AddFoodCompModalOpen])

  const handleModalClose=()=>{
    handleClose();
    dispatch(setFoodcompositionAddFoodCompModal(false));
  }
  return (
    <Modal
       open={AddFoodCompModalOpen===undefined?false:AddFoodCompModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >

        <Grid container direction="row" justifyContent="space-between" alignItems="center"
        sx={{borderBottom:'1px solid #e0e0e0'}}>
          <Grid item>
            <Typography variant="h5"  >
              Add Food Composition @ {foodcompositionObj && foodcompositionObj.title}
            </Typography>
          </Grid>
          <Grid item>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleModalClose()} />
          </Grid>
        </Grid>
        <Grid item paddingTop={1}> 
            < AddFoodCompActionModalContainer/>
        </Grid>

      </Box>
    </Modal>
  );
}